<router-outlet></router-outlet>
<pulse-toasty></pulse-toasty>
